import { Instagram, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0a0a0a] border-t border-neutral-900 overflow-hidden"
    >
      {/* Massive BSE wordmark */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-20 md:pt-24">
        <div className="overflow-hidden -mx-2">
          <h2 className="font-anton uppercase text-white tracking-tighter leading-[0.8] text-[28vw] md:text-[22vw] lg:text-[18rem] whitespace-nowrap select-none">
            BSE<span className="text-[#e11d2a]">.</span>
          </h2>
        </div>
      </div>

      {/* Bottom row */}
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pb-10 md:pb-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end -mt-6 md:-mt-10">
        <div className="md:col-span-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-2">
            Big Stick Energy
          </div>
          <p className="text-neutral-400 text-sm leading-relaxed max-w-xs">
            A youth lacrosse team, an attitude, and a couple of dad-designed
            jerseys. Speak softly. Carry big.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-6">
          <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-3">
            Roster
          </div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li>
              <a
                href="#gear"
                className="hover:text-[#e11d2a] transition-colors"
                data-testid="footer-link-gear"
              >
                Shop the Drop
              </a>
            </li>
            <li>
              <a
                href="#schedule"
                className="hover:text-[#e11d2a] transition-colors"
                data-testid="footer-link-schedule"
              >
                Season Schedule
              </a>
            </li>
            <li>
              <a
                href="#reserve"
                className="hover:text-[#e11d2a] transition-colors"
                data-testid="footer-link-reserve"
              >
                Reserve Gear
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-3 md:col-start-10">
          <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500 mb-3">
            Find Us
          </div>
          <div className="flex items-center gap-3">
            <a
              href="mailto:team@bigstickenergy.lax"
              data-testid="footer-email"
              className="inline-flex items-center justify-center w-10 h-10 border border-neutral-800 text-neutral-300 hover:border-[#e11d2a] hover:text-[#e11d2a] transition-colors"
              aria-label="Email"
            >
              <Mail size={16} />
            </a>
            <a
              href="#"
              data-testid="footer-instagram"
              className="inline-flex items-center justify-center w-10 h-10 border border-neutral-800 text-neutral-300 hover:border-[#e11d2a] hover:text-[#e11d2a] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={16} />
            </a>
          </div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-600 mt-4">
            Memorial Field · USA
          </div>
        </div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-6 border-t border-neutral-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          © 2026 Big Stick Energy Lacrosse · All sticks reserved.
        </div>
        <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-600">
          Designed in the parking lot · Built before practice.
        </div>
      </div>
    </footer>
  );
}
